import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { API } from 'aws-amplify';
import { AddressContainer, AdressSpecific, ButtonContainer } from './address.style';
import { getApplicantProfile } from 'src/graphql/customized_queries';

export default function Address({ addressInformation }) {
  const user = useSelector((state) => state.user.currentUser);
  const address = addressInformation.data.getAddress;
  const [editable, setEditable] = useState(false);
  const [addressData, setAddressData] = useState({
    applicantId: user.id,
    country: '',
    postalCode: '',
    city: '',
    state: '',
    district: '',
    neighborhood: '',
    street: '',
    numInt: '',
    numExt: ''
  });
  //Function that sends the nwe data to dynamo
  const sendDataToServer = async () => {
    const input = {
      type: 'applicant_update_personalAddress',
      input: {
        id: `${user.id}_c`,
        postalCode: addressData.postalCode ? addressData.postalCode : addressInformation.postalCode,
        state: addressData.state ? addressData.state : addressInformation.state,
        district: addressData.district ? addressData.district : addressInformation.district,
        neighborhood: addressData.neighborhood
          ? addressData.neighborhood
          : addressInformation.neighborhood,
        street: addressData.street ? addressData.street : addressInformation.street,
        numInt: addressData.numInt ? addressData.numInt : addressInformation.numInt,
        numExt: addressData.numExt ? addressData.numExt : addressInformation.numExt
      }
    };
    setEditable(false);
  };
  const handleEdit = () => {
    setEditable(true);
  };
  const cancelEdit = () => {
    setEditable(false);
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setAddressData({ ...addressData, [name]: value });
  };

  return (
    <AddressContainer>
      {editable ? (
        <ButtonContainer>
          <button onClick={sendDataToServer}>Aceptar</button>
          <button onClick={cancelEdit}>Cancelar</button>
        </ButtonContainer>
      ) : (
        <ButtonContainer>
          <button onClick={() => setEditable(true)}>Editar</button>
        </ButtonContainer>
      )}
      <AdressSpecific>
        {editable ? (
          <div>
            <h3>Código postal:</h3>
            <input value={addressData.postalCode} onChange={handleInputChange} name="postalCode" />
          </div>
        ) : (
          <div>
            <h3>Código postal:</h3>
            <p>{address?.postalCode ? address?.postalCode : '-'}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Alcaldía o Municipio:</h3>
            <input value={addressData.district} onChange={handleInputChange} name="district" />
          </div>
        ) : (
          <div>
            <h3>Alcaldía o Municipio:</h3>
            <p>{address?.district ? address?.district : '-'}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Ciudad:</h3>
            <input value={addressData.city} onChange={handleInputChange} name="city" />
          </div>
        ) : (
          <div>
            <h3>Ciudad:</h3>
            <p>{address?.city ? address?.city : '-'}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Estado:</h3>
            <input value={addressData.state} onChange={handleInputChange} name="state" />
          </div>
        ) : (
          <div>
            <h3>Estado:</h3>
            <p>{address?.state ? address?.state : '-'}</p>
          </div>
        )}
      </AdressSpecific>
      <AdressSpecific>
        {editable ? (
          <div>
            <h3>Número exterior:</h3>
            <input value={addressData.numExt} onChange={handleInputChange} name="numExt" />
          </div>
        ) : (
          <div>
            <h3>Número exterior:</h3>
            <p>{address?.numExt ? address?.numExt : '-'}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Número interior:</h3>
            <input value={addressData.numInt} onChange={handleInputChange} name="numInt" />
          </div>
        ) : (
          <div>
            <h3>Número interior:</h3>
            <p>{address?.numInt ? address?.numInt : '-'}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Calle:</h3>
            <input value={addressData.street} onChange={handleInputChange} name="street" />
          </div>
        ) : (
          <div>
            <h3>Calle:</h3>
            <p>{address?.street ? address?.street : '-'}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Colonia:</h3>
            <input
              value={addressData.neighborhood}
              onChange={handleInputChange}
              name="neighborhood"
            />
          </div>
        ) : (
          <div>
            <h3>Colonia:</h3>
            <p>{address?.neighborhood ? address?.neighborhood : '-'}</p>
          </div>
        )}
      </AdressSpecific>
    </AddressContainer>
  );
}
